import { useAppSelector } from "@/shared/lib/redux"
import { selectLatestTransactions } from "../../model"
import BroadcastSvg from '@/shared/assets/images/Broadcast.svg'
import { Link } from "react-router-dom"
import { format } from "date-fns"
import { BonusAmountCard } from "@/entities/bonus"

export const LatestTransactionsList = () => {
    const latestTransactions = useAppSelector(selectLatestTransactions)
    return (
        <div className="box h-full">
            <div className="box_header !mb-0">
                Последние начисления
            </div>
            <div className="flex flex-col max-h-[400px] overflow-hidden">
                {latestTransactions.map((transaction) => 
                    <div 
                        key={transaction.id}
                        className='flex items-center justify-between px-2 py-4 border-b border-[#ccc]'
                    >
                        <div className="w-full flex grow-0 overflow-hidden items-center">
                            <div className="min-w-8 min-h-8 bg-color-dark text-color-primary flex items-center justify-center rounded-full">
                                <BroadcastSvg width={18} height={18} />
                            </div>
                            <div className="ml-2 gap-[2px] grow-0 overflow-hidden flex flex-col">
                                <Link to={`/bonuses/transactions/${transaction.id}`} className="text-base overflow-ellipsis overflow-hidden inline-block text-nowrap hover:cursor-pointer hover:underline font-normal">
                                    {transaction.to.name}
                                </Link>
                                <div className="text-[#828282] text-[13px]">
                                    {format(transaction.created_date, 'dd.MM.yyyy')}
                                </div>
                            </div>
                        </div>
                        <BonusAmountCard amountNano={transaction.amount_nano} />
                    </div>
                )}
            </div>
        </div>
    )
}